import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-campus-overview',
  templateUrl: './campus-overview.component.html',
  styleUrls: ['./campus-overview.component.scss']
})
export class CampusOverviewComponent implements OnInit {

  overviewImages = [
    '/assets/img/quick-links/campus/1 (1).jpg',
    '/assets/img/quick-links/campus/1 (2).jpg',
    '/assets/img/quick-links/campus/1 (3).jpg',
    '/assets/img/quick-links/campus/1 (4).jpg',
    '/assets/img/quick-links/campus/1 (5).jpg',
  ];

  constructor() { }

  ngOnInit(): void { }

}
